import { createContext, useContext, useMemo, useState, type ReactNode } from "react";
import { GlobalScopeBar } from "@/features/navigation/GlobalScopeBar";
import { CoachTabStrip, type CoachTab } from "../CoachTabStrip";

/** Page-owned portals keep action handlers and library category ownership intact. */
export const WorkspaceHeaderContext = createContext<{
  heading: HTMLElement | null;
  actions: HTMLElement | null;
  setHeading: (element: HTMLDivElement | null) => void;
  setActions: (element: HTMLDivElement | null) => void;
} | undefined>(undefined);

export function WorkspaceHeaderProvider({ children }: { children: ReactNode }) {
  const [heading, setHeading] = useState<HTMLDivElement | null>(null);
  const [actions, setActions] = useState<HTMLDivElement | null>(null);
  const value = useMemo(() => ({ heading, actions, setHeading, setActions }), [heading, actions]);
  return <WorkspaceHeaderContext.Provider value={value}>{children}</WorkspaceHeaderContext.Provider>;
}

export function WorkspaceHeader({ active, visibleTabs }: {
  active: CoachTab;
  visibleTabs?: ReadonlyArray<CoachTab>;
}) {
  const slots = useContext(WorkspaceHeaderContext);
  return (
    <header className="coach-workspace-header">
      <div className="coach-workspace-heading-row">
        <GlobalScopeBar />
        <div className="coach-workspace-title" ref={slots?.setHeading} />
        <div className="coach-workspace-actions" ref={slots?.setActions} data-testid="coach-workspace-actions" />
      </div>
      <CoachTabStrip active={active} visibleTabs={visibleTabs} />
    </header>
  );
}
